module.exports = __webpack_public_path__ + "img/production-icon.b2d43ff0.svg";